var _circle, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUkrsibbankLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_249_432",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_249_432)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_249_432",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -1,
    width: 52,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2 51H50V-1H-2V51Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_249_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 51H50V-1H-2V51Z",
    fill: "url(#paint0_linear_249_432)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_249_432",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 50,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.332 25.2281C48.332 36.0707 48.8326 47.1733 48.8326 47.1733C48.8132 48.4184 48.0166 49.2144 47.0154 49.2144H2.14926C1.1448 49.2144 0.450627 48.3187 0.332227 47.1733C0.332227 47.1733 -0.962402 37.6949 -0.962402 23.2081C-0.962402 8.72766 0.332227 1.90901 0.332227 1.90901C0.487655 0.718052 1.1448 -0.133416 2.14926 -0.133416H47.0154C48.0166 -0.133416 48.8554 0.799488 48.8326 1.90901C48.8326 1.90901 48.332 14.3851 48.332 25.2281Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_249_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.332 25.2281C48.332 36.0707 48.8326 47.1733 48.8326 47.1733C48.8132 48.4184 48.0166 49.2144 47.0154 49.2144H2.14926C1.1448 49.2144 0.450627 48.3187 0.332227 47.1733C0.332227 47.1733 -0.962402 37.6949 -0.962402 23.2081C-0.962402 8.72766 0.332227 1.90901 0.332227 1.90901C0.487655 0.718052 1.1448 -0.133416 2.14926 -0.133416H47.0154C48.0166 -0.133416 48.8554 0.799488 48.8326 1.90901C48.8326 1.90901 48.332 14.3851 48.332 25.2281Z",
    fill: "url(#paint1_linear_249_432)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_249_432",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 4,
    width: 22,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3501 12.9822C35.1449 14.8635 34.1676 15.0143 30.6885 17.1073L30.8592 16.7203C32.6832 14.7248 33.4779 13.8837 34.6774 12.121C31.4632 12.2954 26.806 12.6801 23.4707 13.4161L23.6475 13.0582C26.6721 11.584 32.2832 10.1196 35.1449 9.74064C34.4489 8.75642 28.76 5.67376 27.3449 5.07862L27.5114 4.71852C31.8203 5.20622 37.5301 7.22619 40.0212 8.75641C41.0725 8.42391 42.1461 8.39173 44.0971 8.22176C44.0971 8.22176 43.8077 9.40069 41.6832 10.8623C42.21 12.2775 40.943 20.1117 39.9006 22.1899C39.8538 18.9127 39.5627 14.7772 38.3501 12.9822Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_249_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3501 12.9822C35.1449 14.8635 34.1676 15.0143 30.6885 17.1073L30.8592 16.7203C32.6832 14.7248 33.4779 13.8837 34.6774 12.121C31.4632 12.2954 26.806 12.6801 23.4707 13.4161L23.6475 13.0582C26.6721 11.584 32.2832 10.1196 35.1449 9.74064C34.4489 8.75642 28.76 5.67376 27.3449 5.07862L27.5114 4.71852C31.8203 5.20622 37.5301 7.22619 40.0212 8.75641C41.0725 8.42391 42.1461 8.39173 44.0971 8.22176C44.0971 8.22176 43.8077 9.40069 41.6832 10.8623C42.21 12.2775 40.943 20.1117 39.9006 22.1899C39.8538 18.9127 39.5627 14.7772 38.3501 12.9822Z",
    fill: "url(#paint2_linear_249_432)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_249_432",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 29,
    width: 13,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9306 41.0661L15.0936 40.7037C13.3917 40.0415 11.6894 39.5189 10.3114 38.2183C10.7453 37.0102 11.2409 36.064 12.0503 34.8672L12.2208 34.5003C10.7587 34.7204 9.4315 35.2574 8.16716 35.5043C7.16945 33.7473 6.78236 31.3438 6.27962 29.0553L6.11356 29.4195C5.8315 32.0306 5.71722 33.8972 6.08991 35.9835C5.03642 36.276 4.11265 36.3177 3.26316 36.6801L3.10156 37.0381C4.45288 37.8739 5.55334 38.5135 7.08237 39.2294C7.89928 40.9901 8.74533 42.1766 10.1145 43.5322L10.2824 43.1698C10.0355 42.169 9.7163 41.3422 9.83676 40.2482C11.5355 40.7448 12.9939 41.0066 14.9306 41.0661Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_249_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9306 41.0661L15.0936 40.7037C13.3917 40.0415 11.6894 39.5189 10.3114 38.2183C10.7453 37.0102 11.2409 36.064 12.0503 34.8672L12.2208 34.5003C10.7587 34.7204 9.4315 35.2574 8.16716 35.5043C7.16945 33.7473 6.78236 31.3438 6.27962 29.0553L6.11356 29.4195C5.8315 32.0306 5.71722 33.8972 6.08991 35.9835C5.03642 36.276 4.11265 36.3177 3.26316 36.6801L3.10156 37.0381C4.45288 37.8739 5.55334 38.5135 7.08237 39.2294C7.89928 40.9901 8.74533 42.1766 10.1145 43.5322L10.2824 43.1698C10.0355 42.169 9.7163 41.3422 9.83676 40.2482C11.5355 40.7448 12.9939 41.0066 14.9306 41.0661Z",
    fill: "url(#paint3_linear_249_432)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_249_432",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 22,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 14.9756C19.6562 14.9756 18.9723 16.1926 18.4245 17.8077H18.2937C22.2848 18.3468 26.0548 19.9665 27.0022 20.5257L26.8339 20.8837C22.6897 20.1543 20.5079 20.2357 18.9643 20.3744C17.4254 20.5234 17.1107 20.7159 17.1107 20.7159C16.2222 22.6621 15.7013 25.8431 15.4901 27.015L15.3241 27.3795C14.5646 25.5546 13.4737 21.9091 13.4737 21.9091C11.3866 23.0312 6.57275 27.5581 6.57275 27.5581C9.2267 22.2572 11.9075 19.8344 11.9075 19.8344C10.9812 18.9038 8.56384 18.4296 6.79812 18.3535L6.96109 17.9956C8.07046 17.6689 10.354 17.5325 11.8852 17.4619C13.6969 17.4072 14.7915 17.511 14.7915 17.511C16.403 16.2238 18.8107 15.0951 19.6562 14.9756Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_249_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 14.9756C19.6562 14.9756 18.9723 16.1926 18.4245 17.8077H18.2937C22.2848 18.3468 26.0548 19.9665 27.0022 20.5257L26.8339 20.8837C22.6897 20.1543 20.5079 20.2357 18.9643 20.3744C17.4254 20.5234 17.1107 20.7159 17.1107 20.7159C16.2222 22.6621 15.7013 25.8431 15.4901 27.015L15.3241 27.3795C14.5646 25.5546 13.4737 21.9091 13.4737 21.9091C11.3866 23.0312 6.57275 27.5581 6.57275 27.5581C9.2267 22.2572 11.9075 19.8344 11.9075 19.8344C10.9812 18.9038 8.56384 18.4296 6.79812 18.3535L6.96109 17.9956C8.07046 17.6689 10.354 17.5325 11.8852 17.4619C13.6969 17.4072 14.7915 17.511 14.7915 17.511C16.403 16.2238 18.8107 15.0951 19.6562 14.9756Z",
    fill: "url(#paint4_linear_249_432)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_249_432",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 37,
    width: 13,
    height: 8
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7354 37.7716C23.8983 38.9093 23.1831 39.8051 22.2599 40.8453C20.8961 41.2247 19.2599 41.0524 18.0001 41.0981L17.835 41.4605C18.7831 41.9495 19.7116 42.2493 20.7055 42.4538C19.9006 43.1875 18.8247 43.7468 18.0702 44.2582L17.9027 44.6147C19.5219 44.2313 21.6542 43.5423 23.242 42.6028C24.068 42.6394 24.8402 42.5848 25.4072 42.4716C25.4072 42.4716 25.5783 42.1017 25.5783 42.1106C25.4734 41.7437 25.1483 41.5199 25.0523 41.0064C26.5411 39.849 27.6207 38.794 28.8648 37.539L29.0367 37.1757C27.8068 38.0258 26.3158 39.1944 24.876 39.8781C24.8166 39.1698 24.7711 38.568 24.7354 37.7716Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_249_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7354 37.7716C23.8983 38.9093 23.1831 39.8051 22.2599 40.8453C20.8961 41.2247 19.2599 41.0524 18.0001 41.0981L17.835 41.4605C18.7831 41.9495 19.7116 42.2493 20.7055 42.4538C19.9006 43.1875 18.8247 43.7468 18.0702 44.2582L17.9027 44.6147C19.5219 44.2313 21.6542 43.5423 23.242 42.6028C24.068 42.6394 24.8402 42.5848 25.4072 42.4716C25.4072 42.4716 25.5783 42.1017 25.5783 42.1106C25.4734 41.7437 25.1483 41.5199 25.0523 41.0064C26.5411 39.849 27.6207 38.794 28.8648 37.539L29.0367 37.1757C27.8068 38.0258 26.3158 39.1944 24.876 39.8781C24.8166 39.1698 24.7711 38.568 24.7354 37.7716Z",
    fill: "url(#paint5_linear_249_432)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5158 12.6164C35.3166 14.5013 34.3381 14.6602 30.8591 16.746C32.8836 14.5438 33.588 13.6065 34.8412 11.7632C31.635 11.9332 26.9742 12.3202 23.6475 13.0584C26.5448 11.5081 32.2868 9.78423 35.3166 9.37396C34.6149 8.40176 28.9252 5.31372 27.5113 4.7187C32.0144 5.06987 37.5203 6.75666 40.1877 8.39191C41.239 8.06307 42.3305 8.04739 44.2831 7.87295C43.7868 8.72969 43.7644 9.22506 41.8484 10.4993C42.3783 11.9229 41.1104 19.7517 40.0627 21.8254C40.0247 18.5504 39.739 14.4141 38.5158 12.6164Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0921 40.7033C13.2541 40.0197 11.9301 39.2245 10.4729 37.8587C10.909 36.6519 11.4068 35.7088 12.2193 34.4999C10.7252 34.7237 9.62332 34.8923 8.33532 35.1361C7.2872 33.2981 6.81166 31.5246 6.27817 29.0549C5.99246 31.6723 5.88446 33.5411 6.2528 35.6238C5.07109 35.9527 4.23406 36.2404 3.26172 36.6797C4.62469 37.5155 5.72514 38.1584 7.24606 38.8698C8.06389 40.6272 8.90904 41.8151 10.2809 43.1694C9.95898 42.0151 9.87417 41.0979 10.0064 39.8868C11.7059 40.3834 13.1613 40.6438 15.0921 40.7033Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8785 14.6645C19.3062 15.4095 18.6418 16.7987 18.4624 17.4438C23.1999 18.0872 27.0022 20.5256 27.0022 20.5256C22.8584 19.7896 20.6753 19.8814 19.1298 20.0201C17.5936 20.1654 17.2781 20.3466 17.2781 20.3466C16.1606 22.8007 15.4901 27.0149 15.4901 27.0149C14.7365 25.193 13.6477 21.5457 13.6477 21.5457C11.557 22.6665 6.74902 27.1982 6.74902 27.1982C9.39188 21.8924 12.0749 19.4787 12.0749 19.4787C11.1517 18.5413 8.73108 18.0737 6.96102 17.9955C7.87931 17.6196 10.2378 17.1799 12.0495 17.0962C13.8629 17.0447 14.9597 17.1476 14.9597 17.1476C16.5771 15.8681 19.0325 14.7897 19.8785 14.6645Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.904 37.4138C24.0684 38.5515 23.3487 39.4441 22.4211 40.483C20.8272 40.9318 19.5549 41.0982 18.0005 41.0982C18.9545 41.5916 19.8787 41.887 20.8741 42.0959C19.8787 42.9988 19.0371 43.6417 18.0705 44.2583C19.6911 43.8735 21.8206 43.1845 23.4068 42.245C24.2349 42.2771 25.0089 42.2234 25.5787 42.1107C25.43 41.6297 25.3384 41.2705 25.2179 40.6441C26.7112 39.4853 27.796 38.4361 29.0371 37.1758C27.7157 38.1005 26.5737 38.7909 25.0438 39.5156C24.9782 38.8088 24.9403 38.2102 24.904 37.4138Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_432",
    x1: 24.0165,
    y1: -2.32451,
    x2: 24.0165,
    y2: 52.5122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7FD2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_249_432",
    x1: 23.9344,
    y1: -13.9501,
    x2: 23.9344,
    y2: 47.6706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#7FD2A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#00A770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835165,
    stopColor: "#007A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B07B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_249_432",
    x1: 33.7834,
    y1: 44.2685,
    x2: 33.7834,
    y2: 4.39174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_249_432",
    x1: 9.09745,
    y1: 44.2704,
    x2: 9.09745,
    y2: 4.3816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_249_432",
    x1: 16.7876,
    y1: 44.2608,
    x2: 16.7876,
    y2: 4.39818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_249_432",
    x1: 23.4356,
    y1: 44.2675,
    x2: 23.4356,
    y2: 4.39115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33B880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A770"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkrsibbankLogo);
export default __webpack_public_path__ + "static/media/ukrsibbank-logo.300bb80126cb04d985cca7f7ef14e5b5.svg";
export { ForwardRef as ReactComponent };